import * as React from 'react'
import { SVGProps } from 'react'
const SvgArrowUp = (props: SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
		<path fill="currentColor" d="M15 20H9v-8H4.16L12 4.16 19.84 12H15v8Z" />
	</svg>
)
export default SvgArrowUp
